import ClientError from 'clients/errors/ClientError';
import ServerError from 'clients/errors/ServerError';
import { getToken } from 'http/clientToken';
import utils from 'helpers/utils';

export default (function () {

    /**
     * Create an XHR request to connect to the MOBIAN API.
     *
     * @param {string} url
     * @param {Object} config - [config={}].
     * @returns {Promise}
     */
    function request(url, config) {
        config = config || {};

        const requestConfig = {
            method: config.method || 'GET',
            credentials: 'include',
            headers: {
                'Accept': 'application/json',
            },
        };

        const clientToken = getToken();

        if (clientToken) {
            requestConfig.headers['Client-Application-Token'] = clientToken;
        }

        if (config.params) {
            url = utils.buildUrl(url, config.params);
        }

        if (config.payload) {
            if (config.type && config.type === 'file') {
                requestConfig.body = config.payload;
            } else {
                requestConfig.body = JSON.stringify(config.payload);
                requestConfig.headers['Content-Type'] = 'application/json';
            }
        }

        return fetch(url, requestConfig).then(function (response) {
            const statusCode = Math.floor(response.status / 100);

            // Client error
            if (statusCode === 4) {
                return response.json().then(function (response) {
                    throw new ClientError('client-error', response.status, response);
                });
            }

            // Server error
            if (statusCode === 5) {
                return response.json().then(function (response) {
                    throw new ServerError('server-error', response.status, response);
                });
            }

            // In case we use the method DELETE we will not receive a json object.
            if (config.method === 'DELETE') {
                return response;
            }

            // If the response is a 204 and thus has no content, we return nothing.
            if (response.status === 204) {
                return null;
            }

            return response.json();
        }, function (error) {
            throw new Error(error);
        });
    }

    return {
        create: function (url, payload) {
            return request(url, {
                method: 'POST',
                payload,
            });
        },
        createFile: function (url, payload) {
            return request(url, {
                method: 'POST',
                type: 'file',
                payload,
            });
        },
        read: function (url, params) {
            return request(url, {
                method: 'GET',
                params,
            });
        },
        update: function (url, payload) {
            return request(url, {
                method: 'PUT',
                payload,
            });
        },
        patch: function (url, payload) {
            return request(url, {
                method: 'PATCH',
                payload,
            });
        },
        delete: function (url) {
            return request(url, {
                method: 'DELETE',
            });
        },
    };
})();



// WEBPACK FOOTER //
// ./src/clients/apiClient.js